module.exports = __webpack_public_path__ + "media/images/service-1-cf4e2f5515978207337ea7ee8eaf2916.png";